var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFireFlameCurved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 320C384 425.875 297.875 512 192 512S0 425.875 0 320C0 261.328 27.812 213.156 54.562 185.047C69.531 169.313 96 179.844 96 201.547V287.047C96 322.219 123.969 351.547 159.156 351.985C194.875 352.453 224 323.625 224 288C224 200 48 191.844 171.844 10.813C185.344 -8.906 216 0.063 216 23.86C216 127 384 149.703 384 320Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireFlameCurved);
export default __webpack_public_path__ + "static/media/fire-flame-curved.928b3e9916eb2602ef44599db6179c53.svg";
export { ForwardRef as ReactComponent };